import { Constants } from "appConstants";
import { IcoArrowLeft } from "assets/icons";
import { Button, Line } from "components";
import { useFormik } from "formik";
import { DateTimeHelper } from "helpers";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.scss";

export interface BaseFormProps {
	children: (formik: any) => React.ReactNode;
	initialValues: any;
	isEditForm: boolean;
	isTermForm?: boolean;
	isSubmitting: boolean;
	onSubmit: (data: any) => void;
	cancel?: () => void;
	validationSchema: any;
	title: string;
}

export default function BaseForm(props: Readonly<BaseFormProps>) {
	const {
		children,
		initialValues,
		isEditForm,
		isSubmitting,
		onSubmit,
		cancel = () => {},
		validationSchema,
		title
	} = props;
	const navigate = useNavigate();
	const formik = useFormik({
		initialValues,
		validationSchema,
		onSubmit,
		validateOnMount: true,
		validateOnBlur: true,
		enableReinitialize: true
	});

	const isEditTerm = title === Constants.strings.pages.term.editTerm;

	useEffect(() => {
		if (formik.values?.startDate) {
			if (formik.values.startDate !== DateTimeHelper.getCurrentDate()) {
				formik.setFieldValue("activateNow", false);
			} else formik.setFieldValue("activateNow", true);
		}
	}, [formik.values?.startDate]);

	return (
		<div
			style={{
				height: "inherit"
			}}
		>
			<div className="form-wrapper">
				<form className="container-wrapper" onSubmit={formik.handleSubmit}>
					<div className="p-4 flex flex-row justify-start align-center space-x-4 items-center">
						<Button kind="icon" styled="ghost" onClick={() => navigate(-1)}>
							<IcoArrowLeft color="#000000" size="16" />
						</Button>
						<p className="font-semibold">{title}</p>
					</div>
					<Line height={2} />
					<div className="px-8 py-6 space-y-4">{children(formik)}</div>
					<Line height={2} />
					<div className="px-8 py-6 flex flex-row gap-6 justify-end">
						<Button
							styled="ghost"
							kind="link"
							onClick={() => (isEditTerm ? cancel() : navigate(-1))}
						>
							{isEditTerm
								? Constants.strings.inputs.exclude
								: Constants.strings.inputs.cancel}
						</Button>
						<Button
							styled="primary"
							type="submit"
							isLoading={isSubmitting}
							disabled={!formik.isValid}
						>
							{isEditForm
								? Constants.strings.inputs.save
								: Constants.strings.inputs.register}
						</Button>
					</div>
				</form>
			</div>
		</div>
	);
}
